var Ribbon_default = {
  "ribbon": "cEnUY",
  "ribbonText": "Ktap-",
  "imageRibbon": "hW-YV"
};
export {
  Ribbon_default as default
};
//# sourceMappingURL=Ribbon-scss.js.map
